export default class MeanChangeAdjData {
    constructor(
        refTime,
        meanChangeAdj,
        period
    ) {
        this.refTime = refTime;
        this.meanChangeAdj = meanChangeAdj;
        this.period = period;
    }
}
